(() => {
  function initCategories(root) {
    const tabs = [...root.querySelectorAll('[data-category-tab]')];
    const panels = [...root.querySelectorAll('[data-category-panel]')];
    if (!tabs.length || panels.length !== tabs.length) return;
    function activate(tab, focus) {
      tabs.forEach(item => { const current = item === tab; item.setAttribute('aria-selected', String(current)); item.tabIndex = current ? 0 : -1; });
      panels.forEach(panel => { panel.hidden = panel.dataset.categoryPanel !== tab.dataset.categoryTab; });
      if (focus) tab.focus();
    }
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(tab, false));
      tab.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
        activate(tabs[next], true);
      });
    });
    const requested = new URLSearchParams(location.search).get('category');
    const initial = tabs.find(tab => tab.dataset.categoryTab === requested);
    if (initial) activate(initial, false);
  }

  function initInterest() {
    const interest = new URLSearchParams(location.search).get('interest');
    const field = document.querySelector('#ContactForm-body');
    if (!interest || !field || field.value.trim()) return;
    const names = {
      'logo-brand-stickers': 'Logo & brand stickers', 'decorative-stickers': 'Decorative stickers', 'envelope-seals': 'Envelope seals', 'custom-shapes': 'Custom shapes',
      'product-labels': 'Product labels', 'jar-bottle-labels': 'Jar & bottle labels', 'thank-you-labels': 'Thank-you labels', 'address-labels': 'Address labels',
      'hang-tags': 'Hang tags', 'packaging-inserts': 'Packaging inserts', 'belly-bands': 'Belly bands', 'packaging-sleeves': 'Packaging sleeves',
      'business-cards': 'Business cards', 'postcards': 'Postcards', 'invitations': 'Invitations', 'bookmarks': 'Bookmarks'
    };
    if (names[interest]) field.value = `I’m interested in ${names[interest]}.\n\nHere is what I have in mind: `;
  }

  function init() {
    document.querySelectorAll('[data-categories]').forEach(initCategories);
    initInterest();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
})();
